import React from 'react';
import './App.css';
import LandingPageComponent from './screens/landing-page/LandingPage.component';
import AppRouter from './App.routing';

function App() {
  return (
    <AppRouter/>
  );
}

export default App;
